export default __webpack_public_path__ + "static/media/ic_just4u.7d76ca5d.svg";